<template>
  <vxe-grid
    ref="docTable"
    auto-resize
    highlight-hover-row
    resizable
    border
    size="mini"
    row-id="amzFtyNoticeOutDocId"
    :toolbar-config="tableToolbar"
    :data="tableData"
    :columns="tableColumns"
    :loading="loading"
    :edit-config="{
      enabled: !disabled,
      trigger: 'click',
      mode: 'row',
    }"
    :edit-rules="editRules"
    :checkbox-config="{
      enabled: enabledReadBox,
      highlight: true,
      reserve: true,
      checkMethod: ({ row }) => !!row.amzFtyNoticeOutDocCode,
    }"
    @checkbox-change="checkboxChange"
    @checkbox-all="checkboxChange"
  >
    <template v-slot:toolbar_form>
      <slot name="header"></slot>
    </template>
    <template v-slot:opt="{ row }">
      <div>
        <el-tooltip
          v-if="row.fileCode"
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_preview') || '预览'"
          placement="top"
        >
          <i class="el-icon-view tool-btn" @click="preview(row)"></i>
        </el-tooltip>
        <el-tooltip
          v-if="row.fileCode"
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_downloada') || '下载'"
          placement="top"
        >
          <i class="el-icon-download tool-btn" @click="downloadFile(row)"></i>
        </el-tooltip>
        <el-tooltip
          v-if="!disabled"
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_del') || '删除'"
          placement="top"
        >
          <i class="el-icon-delete tool-btn" @click="remove(row)"></i>
        </el-tooltip>
      </div>
    </template>
  </vxe-grid>
</template>

<script>
import lodash from 'lodash'
import tableColumns from './table-columns'
export default {
  props: {
    loading: { type: Boolean, default: false },
    tableData: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: this.disabled ? { query: () => this.$emit('reload') } : null,
        zoom: true,
        custom: true,
      },
      editRules: {
        ftyNoticeOutDocType: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
          },
        ],
      },
    }
  },
  computed: {
    enabledReadBox() {
      return !!this.allow('RB') && !this.disabled
    },
    tableColumns() {
      return tableColumns(this)
    },
  },
  watch: {
    tableColumns: {
      handler() {
        this.$refs.docTable.refreshColumn()
      },
      deep: true,
    },
  },
  methods: {
    downloadFile({ fileCode }) {
      this.$api.SYS_FILEDOWNLOAD(fileCode)
    },
    preview({ fileCode }) {
      this.$api.SYS_FILEDOWNLOAD(fileCode, { preview: true, isAutoDown: true })
    },
    async remove(row) {
      await this.$refs.docTable.setCheckboxRow(row, false)
      await this.$refs.docTable.remove(row)

      this.$emit('checkbox-change', this.getCheckboxRecords())
    },
    insertAt(records, row = -1) {
      return this.$refs.docTable.insertAt(records, row)
    },
    async getTableData() {
      const { tableData } = await this.$refs.docTable.getTableData()
      return tableData
    },
    async validate() {
      const result = await this.$refs.docTable.validate(true)
      return !result
    },
    checkboxChange({ records, reserves }) {
      this.$emit('checkbox-change', records.concat(reserves))
    },
    clearCheckboxRow() {
      this.$refs.docTable.clearCheckboxRow()
      this.$refs.docTable.clearCheckboxReserve()
      this.$emit('checkbox-change', [])
    },
    getCheckboxRecords() {
      return lodash.concat(
        this.$refs.docTable.getCheckboxRecords(),
        this.$refs.docTable.getCheckboxReserveRecords()
      )
    },
  },
}
</script>
